import axios from "axios"

export const END_POINT = {
  ACCOUNT_INFO: "/kiban/com/user/accountInfo:get.do",
} as const

type UserAccountInfo = {
  id: string
  userName: string
  companyName: string | null
  lastViewedDateOfWhatsNew: string | null
  hasVolumeDiscountInfo: boolean
  currentVolumeDiscountUserLevel: string
  currentDiscountPercent: number
}

const userApi = {
  async accountInfo() {
    const res = await axios.get<UserAccountInfo | "">(END_POINT.ACCOUNT_INFO)

    return res.data || null
  },
} as const

export default userApi
